(ns entities.key-accomplishments.events
  (:require
    [very.re-frame.core :as rf]
    [graphql.core :as qu]
    [entities.key-accomplishments.specs :as sp]))

(def path [:entities :key-accomplishments])

(rf/reg-entity
  :key-accomplishments
  {:get
   (fn [cfx]
     {:graphql {:gql (qu/key-accomplishments)
                :success [:key-accomplishments/fetched]
                :error [:key-accomplishments/fetch-errored]
                :cancellable? true}})

   :post
   (fn [cfx [{:keys [data]}]]
     {:graphql {:gql (qu/create-key-accomplishments
                       {:input {:value-relationships
                                (map #(clojure.set/rename-keys % {:date-completed :date}) data)}})
                :success [:key-accomplishments/created]
                :error [:key-accomplishments/create-errored]}})
   })

(defn- coerce [e]
  (clojure.set/rename-keys e {:date :date-completed}))

(rf/reg-event-db
  :key-accomplishments/fetched
  (rf/path path)
  (fn [_ [data]]
    (map coerce (get-in data [:client :key-accomplishments]))))

(rf/reg-event-db
  :key-accomplishments/fetch-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (map coerce (get-in data [:client :key-accomplishments]))))

(rf/reg-event-db
  :key-accomplishments/created
  (rf/path path)
  (fn [_ [data]]
    (map coerce (get-in data [:create-key-accomplishments]))))

(rf/reg-event-db
  :key-accomplishments/create-errored
  (rf/path path)
  (fn [_ [{:keys [data]}]]
    (map coerce (get-in data [:create-key-accomplishments]))))

